import React from "react";
import Skeleton from "@mui/material/Skeleton";

const RecipeCardSkeleton = () => {
  return <Skeleton variant="rectangular" className="w-full pt-[100%] rounded-lg" />;
};

export default RecipeCardSkeleton;
